const atgUserManagementContent = {
  list: {
    addAccount: 'Ajouter un compte',
    selectedAccounts: 'Comptes selectionnes',
    accountGroup: 'Groupe de comptes',
    accountNumber: 'No de compte',
    authorizedDivisions: 'Division(s) autorisee(s)',
    accountName: 'Nom du compte',
    city: 'Ville',
    state: 'État/Province',
    zipCode: 'Code postal/Code ZIP',
    deleteAccounts: 'Supprimer le(s) compte(s)',
    deleteCount: 'Supprimer {{count}} compte',
    emptyState: 'Aucun compte selectionne. Cliquez sur "Ajouter un compte" pour selectionner des comptes.',
    searchForAccounts: 'Rechercher des comptes',
    searchCriteriaHint: '(Division, type de compte et un critere supplementaire requis)',
    atgDivision: 'Division ATG',
    selectDivision: 'Selectionner une division',
    accountType: 'Type de compte',
    selectAccountType: 'Selectionner un type de compte',
    divisionRequired: 'La division est requise.',
    accountTypeRequired: 'Le type de compte est requis.',
    country: 'Pays',
    selectCountry: 'Selectionner un pays',
    selectState: 'Selectionner une province',
    search: 'Rechercher',
    reset: 'Reinitialiser',
    resultsTitle: 'Resultats correspondant a vos criteres :',
    selectAccountDivision: 'Selectionner la division du compte',
    selectAll: 'Tout selectionner',
    selectedCount: '{{count}} selectionnes',
    clearAll: 'Tout effacer',
    noResults: 'Aucun resultat trouve.',
    close: 'Fermer',
    linkedAccounts: 'Comptes lies',
  },
  addUser: {
    title: 'Ajouter un utilisateur',
    subtitle: 'Remplissez les details ci-dessous pour creer un nouveau compte utilisateur.',
    firstName: 'Prenom',
    lastName: 'Nom',
    email: 'Courriel',
    businessPhone: 'Telephone professionnel',
    address: 'Adresse',
    city: 'Ville',
    country: 'Pays',
    state: 'État/Province',
    active: 'Actif',
    activeStatus: 'Statut actif',
    userRole: 'Role utilisateur',
    language: 'Langue',
    zipCode: 'Code postal/Code ZIP',
    selectCountry: 'Selectionner un pays',
    selectState: 'Selectionner une province',
    selectActiveStatus: 'Selectionner un statut actif',
    selectUserRole: 'Selectionner un role utilisateur',
    firstNameRequired: 'Le prenom est requis.',
    lastNameRequired: 'Le nom est requis.',
    emailRequired: 'Le courriel est requis.',
    emailInvalid: 'Veuillez saisir une adresse courriel valide.',
    businessPhoneRequired: 'Le telephone professionnel est requis.',
    businessPhonePattern: 'Le telephone professionnel doit contenir uniquement des chiffres.',
    businessPhoneMinLength: 'Le telephone professionnel doit contenir au moins 7 chiffres.',
    businessPhoneMaxlength: 'Le telephone professionnel ne doit pas depasser 10 chiffres.',
    addressRequired: 'L\'adresse est requise.',
    cityRequired: 'La ville est requise.',
    countryRequired: 'Le pays est requis.',
    stateRequired: 'La province est requise.',
    activeRequired: 'Le statut actif est requis.',
    userRoleRequired: 'Le role utilisateur est requis.',
    languageRequired: 'La langue est requise.',
    zipCodeRequired: 'Le code postal/code ZIP est requis.',
    accountSelectionRequired: 'Veuillez associer au moins un compte pour continuer.',
    createSuccess: 'Utilisateur cree avec succes',
    createFailed: 'Echec de creation de l\'utilisateur. Veuillez reessayer.',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    cancel: 'Annuler',
    accountStatus: 'Statut du compte',
  },
  editUser: {
    userDetails: 'Details de l\'utilisateur',
    accountStatus: 'Statut du compte',
    customerName: 'Nom du compte',
    email: 'Courriel',
    accountActivatedDate: 'Date d\'activation du compte',
    activatedBy: 'Active par',
    userRole: 'Role utilisateur',
    dateFormat: 'Format de date',
    phoneNumber: 'Numero de telephone',
    phoneNumberPattern: 'Veuillez saisir uniquement des chiffres.',
    phoneNumberMinLength: 'Le numéro de téléphone doit contenir au moins 7 chiffres.',
    phoneNumberMaxlength: 'Le numéro de téléphone ne doit pas dépasser 10 chiffres.',
    salesDistrict: 'District des ventes',
    salesGroup: 'Groupe des ventes',
    salesOffice: 'Bureau des ventes',
    group: 'Groupe',
    language: 'Langue',
    selectLanguage: 'Selectionner une langue',
    addressLine1: 'Adresse ligne 1',
    addressLine2: 'Adresse ligne 2',
    city: 'Ville',
    country: 'Pays',
    selectCountry: 'Selectionner un pays',
    state: 'État/Province',
    selectState: 'Selectionner une province',
    zipCode: 'Code postal/Code ZIP',
    postalCode: 'Code postal/Code ZIP',
    userCreatedOn: 'Utilisateur cree le',
    lastLoginDate: 'Date de derniere connexion',
    emailSentDate: 'Date d\'envoi du courriel',
    emailSentBy: 'Courriel envoye par',
    createOrder: 'Creer une commande',
    reviewAccounts: 'Revoir les comptes',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    cancel: 'Annuler',
    resetPassword: 'Reinitialiser le mot de passe',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    enterOldPassword: 'Saisir l\'ancien mot de passe',
    enterNewPassword: 'Saisir le nouveau mot de passe',
    confirmNewPasswordPlaceholder: 'Confirmer le nouveau mot de passe',
    submit: 'Soumettre',
    submitting: 'Soumission...',
    accountSelectionRequired: 'Veuillez associer au moins un compte pour continuer.',
    requestAccountAccess: 'Demander l\'acces au compte',
    requestAccessSuccess: 'Demande d\'acces au compte soumise avec succes',
    passwordUpdateSuccess: 'Mot de passe mis à jour avec succès',
  },
};

export const atgUserManagement = {
  ...atgUserManagementContent,
  atgUserManagement: atgUserManagementContent,
};
